const buttonCommonTheme = {
  buttonCommonClasses: 'flex items-center justify-center gap-2 disabled:pointer-events-none',
};

export default buttonCommonTheme;
